import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import SeasonAdmin_nav from './SeasonAdmin_nav';
import moment from 'moment';

const ADMIN_LVL_SEASONS = 3;

class SeasonAdmin_subs extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			season: this.props.season
		};
	
		this.createSubseasonRow = this.createSubseasonRow.bind(this);
		this.handleEditSubseason = this.handleEditSubseason.bind(this);
		this.handleDeleteSubSeason = this.handleDeleteSubSeason.bind(this);
	}

 	componentDidMount() {
		// console.log('SeasonAdmin_subs: componentDidMount');
		this.setState({
			season: this.props.season,
		});
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// console.log('SeasonAdmin_subs: UNSAFE_componentWillReceiveProps: ');
		this.setState({
			season: nextProps.season,
		});
	}

	render() {
		// console.log('SeasonAdmin_subs: RENDER');

		// Prevent undefined causing errors when reloading page (props not being set early)
		var subSeasons = [];
  	var subSeasonsLength = 0;
  	if (this.state.season.subSeasons) {
  		subSeasons = this.state.season.subSeasons
  		subSeasonsLength = this.state.season.subSeasons.length;	
  	}

		// console.log(subSeasons);

    // ADMIN LEVEL REQUESTED:  03-SEASON
    if (this.props.adminAccess.adminValidatedAccessLevel > ADMIN_LVL_SEASONS) {

      return (
        <div className="col-md-9">   {/*padding-left already set in parent*/} 
          <p>Vous n'avez pas accès à cette section pour la saison sélectionnée</p>
        </div>
      );
        
    } else {

			if(this.state.season._id === "0") {
	      return (
          <div className="col-md-9">   {/*padding-left already set in parent*/} 
            <p>Vous devez d'abord créer une saison pour cette ligue dans l'onglet Ligue</p>
          </div>
        );

			} else {

				return (
          <div>
	        	<SeasonAdmin_nav adminAccess={this.props.adminAccess} season={this.state.season} />

						<div className="card">
							<div className="card-header">
							<i className="fa fa-th-large"></i>
								Sous-saisons
							</div>

							<div className="card-block table-responsive">
							<table className="table table-striped table-hover table-sm">
							<tbody>
								<tr>
									<th></th>
	                <th>Id</th>
									<th>Sous-saisons</th>
	                <th>Début</th>
	                <th>Divisions</th>
	                <th>Finale</th>
	                <th></th>
								</tr>
								{subSeasons.map(this.createSubseasonRow)}
							</tbody>
							</table>
							</div>
						</div>

            <div className="row">
	            <div className="col-md-12">
								<Link to={"/admsafe/subseason/add/" + subSeasonsLength} 
									className="btn btn-primary"> Ajouter une Sous-saison </Link>

								<br/><br/>
								(Données sauvegardées automatiquement)
								<br/><br/><br/>	
	            </div>
            </div>

          </div>
        );
			}
		}
  }

  createSubseasonRow(subseason, subSeasonIdx) {

  	var typeFinals = "";
  	if (subseason.typeFinals) {
  		typeFinals = "FINALE";
  	}

		var startDate = moment(subseason.startDate).utc().format("YYYY-MM-DD");
		return (
			<tr key={subseason.id}>
        <td><input name={'edit.' + subseason.id} type="button" onClick={this.handleEditSubseason} value="Éditer"/></td>
				<td>{subseason.id}</td>
				<td>{subseason.name}</td>
				<td>{startDate}</td>
				<td>{subseason.divisions.length}</td>
				<td>{typeFinals}</td>
        <td><input id={"remSubSeason." + subSeasonIdx} type="button" onClick={this.handleDeleteSubSeason} value="Supprimer"/></td>
      </tr>
    );
  }

  handleEditSubseason(e) {
    var elemInfo = e.target.name.split(".");
    var subseasonEditId = elemInfo[1];
    const path = "/admsafe/subseason/" + subseasonEditId;
    this.props.history.push(path);
  }

	handleDeleteSubSeason(e) {

		// Autosave post to database
		var _this = this;
		var ssIdx = parseInt(e.target.id.split(".")[1]);

		var season = this.state.season;
		season.subSeasons.splice(ssIdx, 1);

		// reIndex data
		season.subSeasons.forEach(function(ssItem, ssIdx) {
			ssItem.id = String(ssIdx);
		});

		this.setState({
			season: season
		});

		Axios.post('/api/seasons/' + _this.state.season._id, {
			season: _this.state.season,
		})
		.then(function(response) {
			// console.log(response);
			// RELOAD
		})
		.catch(function(error) {
			console.log(error);
		});
	}

}

export default SeasonAdmin_subs;
